export default __webpack_public_path__ + "static/media/Telugu_am_2.041c8c2e.mp3";